import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Button, Typography } from '@material-ui/core';

const ModalEmpresaMigrada = ({ open, close, dados }) => {

    return (
        <Dialog fullWidth maxWidth={'sm'}
            open={open}
            onClose={close}
        >
            <DialogTitle>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row', justifyContent: 'space-between', width: "100%", alignItems: 'center',
                    backgroundColor: '#fff'
                }}>
                    <div style={{
                        display: 'flex', width: "100%", flexDirection: "row"
                    }} >
                        <Typography>{dados.razao_social}</Typography>
                    </div>
                    <div style={{
                        display: 'flex', width: "100%", justifyContent: 'flex-end'
                    }}>
                        <IconButton
                            aria-label="close"
                            onClick={close}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent style={{ backgroundColor: '#fff', }} >
                <DialogContentText style={{ alignItems: 'flex-start' }}>
                    <Typography style={{ fontWeight: 'bold', textAlign: "left", color: 'black', marginBottom: 8 }}>
                        Empresa migrada para o novo sistema
                    </Typography>
                    <Typography style={{ textAlign: 'left', color: '#555', marginBottom: 12 }}>
                        Sua empresa já está disponível no novo ambiente de emissão. Acesse abaixo para continuar o trabalho.
                    </Typography>

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: "100%", alignItems: 'center' }}>
                        <Button variant='contained' color="primary"
                            onClick={() => {
                                window.open("https://nfse.abrsolucoesdigitais.com", '_blank').focus();
                            }}
                            style={{
                                marginTop: 15, color: "#fff", borderColor: "#4d79ff", borderWidth: 2, marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block',
                            }}>
                            Acessar o novo sistema
                            <OpenInNewIcon style={{ color: "#fff", marginLeft: 5 }} size={30} />
                        </Button>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog >
    )

}

export default ModalEmpresaMigrada;
